import { r as registerInstance, h, H as Host } from './index-c269755a.js';

const LinkVariant = {
  TEXT: 'text',
  STANDALONE: 'standalone',
  NAVIGATION: 'navigation',
};
Object.values(LinkVariant);

const teliaLinkCss = ":host(.standalone){display:flex}.telia-link__link ::slotted([slot=left]){margin-right:calc(0.8rem * var(--voca-rem-multiplier));padding-top:calc(0.2rem * var(--voca-rem-multiplier))}.telia-link__link ::slotted([slot=right]){margin-left:calc(0.8rem * var(--voca-rem-multiplier));padding-top:calc(0.2rem * var(--voca-rem-multiplier))}";

const TeliaLink = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    /** A silent link is intended to wrap an element
     * to make it a link but not add any styling
     * except for the pointer cursor and focus style. */
    this.silent = false;
    /**
     * Determines if link is displayed on its own line
     * (standalone) or within the current text content
     * (text).
     */
    this.variant = LinkVariant.TEXT;
    /** Disables visited styling */
    this.disableVisited = false;
    /**
     * When used on a dark background, set this
     * property to true. This will change color of text
     * and hover to something suitable.
     */
    this.darkBackground = false;
    /** Tracking id is used to identify and count Component usage */
    this.dataTrackingId = 'telia-link';
  }
  render() {
    const componentClass = 'telia-link';
    const linkClasses = {
      [componentClass]: true,
      standalone: this.variant === 'standalone',
    };
    return (h(Host, { class: linkClasses }, h("telia-style-link", { silent: this.silent, variant: this.variant, "data-testid": this.dataTestid, "disable-visited": this.disableVisited, "dark-background": this.darkBackground }, h("a", { href: this.href, target: this.target, download: this.download, "referrer-policy": this.referrerPolicy, title: this.linkTitle, class: `${componentClass}__link` }, h("slot", { name: "left" }), h("slot", null), h("slot", { name: "right" }))), h("telia-vst", { dataTrackingId: this.dataTrackingId })));
  }
};
TeliaLink.style = teliaLinkCss;

const teliaStyleLinkCss = ".telia-style-link a{align-items:center;color:inherit;cursor:pointer;text-decoration:underline}.telia-style-link a:focus{outline:solid calc(0.3rem * var(--voca-rem-multiplier)) #0099ff;outline-offset:0}.telia-style-link a:focus:not(:focus-visible){outline:0}.telia-style-link--text:not(.telia-style-link--disable-visited) a:visited,.telia-style-link--standalone:not(.telia-style-link--disable-visited) a:visited{color:#30004b;background-color:transparent}.telia-style-link--text:not(.telia-style-link--disable-visited) a:visited:hover,.telia-style-link--standalone:not(.telia-style-link--disable-visited) a:visited:hover{color:#5e0092}.telia-style-link--text:not(.telia-style-link--disable-visited) a:visited:active,.telia-style-link--standalone:not(.telia-style-link--disable-visited) a:visited:active{color:#30004b}.telia-style-link--text:not(.telia-style-link--disable-visited) a:hover,.telia-style-link--standalone:not(.telia-style-link--disable-visited) a:hover{color:#5e0092;background-color:#fbf0ff}.telia-style-link--text:not(.telia-style-link--disable-visited) a:active,.telia-style-link--standalone:not(.telia-style-link--disable-visited) a:active{color:#30004b;background-color:#fbf0ff}.telia-style-link--standalone a{font-family:\"TeliaSans\", Helvetica, Arial, \"Lucida Grande\", sans-serif;font-weight:normal;font-size:calc(1.6rem * var(--voca-rem-multiplier));line-height:1.5;color:#990ae3;display:inline-block;padding:calc(1rem * var(--voca-rem-multiplier)) 0}.telia-style-link--navigation a{font-family:\"TeliaSans\", Helvetica, Arial, \"Lucida Grande\", sans-serif;font-weight:500;font-size:calc(1.6rem * var(--voca-rem-multiplier));line-height:1.25;align-items:center;display:flex;text-decoration:none}@media screen and (min-width: 64em){.telia-style-link--navigation a{font-size:calc(1.4rem * var(--voca-rem-multiplier))}}.telia-style-link--navigation a:hover{text-decoration:underline}.telia-style-link--navigation a:hover.telia-style-link--dark-bg{background-color:transparent}.telia-style-link--dark-bg:not(.telia-style-link--disable-visited) a{color:#e8e8ed}.telia-style-link--dark-bg:not(.telia-style-link--disable-visited) a:visited{color:#de99ff}.telia-style-link--dark-bg:not(.telia-style-link--disable-visited) a:visited:hover{color:#edc8ff}.telia-style-link--dark-bg:not(.telia-style-link--disable-visited) a:visited:active{color:#de99ff}.telia-style-link--dark-bg:not(.telia-style-link--disable-visited) a:hover{color:#edc8ff;background:rgba(255, 255, 255, 0.1)}.telia-style-link--dark-bg:not(.telia-style-link--disable-visited) a:active{color:#de99ff}.telia-style-link--silent a{background-color:inherit;color:inherit;height:100%;text-decoration:none}.telia-style-link--silent a:hover{background-color:inherit;color:inherit}.telia-style-link--silent a:focus{background-color:inherit;color:inherit;outline:0}.telia-style-link--silent a:focus ::slotted(*){outline:solid calc(0.3rem * var(--voca-rem-multiplier)) #0099ff;outline-offset:calc(0.2rem * var(--voca-rem-multiplier))}.telia-style-link--silent a:active{background-color:inherit;color:inherit}";

const TeliaStyleLink = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    /** A silent link is intended to wrap an element
     * to make it a link but not add any styling
     * except for the pointer cursor and focus style. */
    this.silent = false;
    /**
     * Determines if link is displayed on its own line
     * (standalone) or within the current text content
     * (text).
     */
    this.variant = LinkVariant.TEXT;
    /** Disables visited styling */
    this.disableVisited = false;
    /**
     * When used on a dark background, set this
     * property to true. This will change color of text
     * and hover to something suitable.
     */
    this.darkBackground = false;
    /** Tracking id is used to identify and count Component usage */
    this.dataTrackingId = 'telia-style-link';
  }
  render() {
    const componentClass = 'telia-style-link';
    const linkClasses = {
      [componentClass]: true,
      [`${componentClass}--${this.variant}`]: true,
      [`${componentClass}--silent`]: this.silent,
      [`${componentClass}--dark-bg`]: this.darkBackground,
      [`${componentClass}--navigation-dark-bg`]: this.darkBackground && this.variant === 'navigation',
      [`${componentClass}--disable-visited`]: this.disableVisited || this.silent,
    };
    return (h(Host, { class: linkClasses }, h("slot", null), h("telia-vst", { dataTrackingId: this.dataTrackingId })));
  }
};
TeliaStyleLink.style = teliaStyleLinkCss;

export { TeliaLink as telia_link, TeliaStyleLink as telia_style_link };
